export { InfoModal } from "./InfoModal";
export type { InfoModalProps } from "./InfoModal";
